<template>
  <v-container :class="['pb-0', 'page-header', 'px-3']">
    <div :class="['px-2']">
      <h2 :class="['font-weight-light', 'headline', 'pb-3']" v-html="setHeaderText" />
      <v-divider />
    </div>
  </v-container>
</template>
<script>
import menu from '../helpers/menu'

export default {
  name: 'PageHeader',
  data () {
    return {
      menu
    }
  },
  computed: {
    setHeaderText () {
      let header = null
      const path = this.$route.path
      const menu = this.menu
      if (path.indexOf('methods') === -1) {
        header = menu.find(item => item.url === path).label
      } else {
        header = this.$lang.method(this.$route.params.method)
      }
      document.title = `${this.$config.appName} | ${header.replace('&raquo;', '|')}`
      return header
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-header.vue